import { useRef, useState } from "react"
import { SectionHeading, TableCustom, WrapperAdvancedSearch } from "../../components/common"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import { ServerRequest } from "../../utils/apiweb"
import { REQUEST_METHOD } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { PERMISSIONS } from "../../consts/permissions"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import RubroModal from "../../components/controls/RubroModal"
import { getDateToString } from "../../utils/convert"

const RubrosView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [rubros, setRubros] = useState([])
    const [editItem, setEditItem] = useState()
    const [editMode, setEditMode] = useState()
    const [tableVisible, setTableVisible] = useState(false)

    const searchRef = useRef()
    
    const { hasPermission } = usePermissions();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);

    const filterData = data => {
        const { codigo, nombre, regimenGeneral } = searchRef.current.filters

        let filtered = [...data]

        if (codigo !== '') filtered = filtered.filter(rubro => rubro.codigo.toLowerCase().includes(codigo.toLowerCase()))
        if (nombre !== '') filtered = filtered.filter(rubro => rubro.nombre.toLowerCase().includes(nombre.toLowerCase()))
        if (regimenGeneral) filtered = filtered.filter(rubro => rubro.regimenGeneral)

        return filtered
    }

    const SearchRubros = () => {
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RUBRO,
            null,
            null,
            res => res.json().then(data => {
                setRubros(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.RUBRO,
            `/${id}`,
            null,
            () => {
                SearchRubros()
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                nombre: '',
                orden: '',
                agrupamiento: '',
                fechaBaja: null,
                facturable: false,
                generico: false,
                categoria: '',
                importeMinimo: 0,
                alicuota: 0,
                regimenGeneral: true,
                idTipoMinimoAplicable: 0,
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el registro?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    const onEditConfirm = () => {
        if (tableVisible) SearchRubros()
        else {
            setEditMode(null)
            setEditItem(null)
        }
    }

    const onEditCancel = () => {
        setEditMode(null)
        setEditItem(null)
    }

    return <>
        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Rubros' }]}
                        onAddClick={canEdit ? avmr.onAdd : null} tableVisible={tableVisible} />

        <section className="section-accordion">
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 5 },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 4 },
                    {
                        title: 'Régimen',
                        field: 'regimenGeneral',
                        type: 'segmented',
                        size: 3,
                        options: [
                            { value: null, label: 'Todos' },
                            { value: true, label: 'General' },
                        ],
                    },
                ]}
                onSearch={SearchRubros}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={rubros}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '20%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '20%', },
                        { Header: 'Agrupamiento', accessor: 'agrupamiento', width: '20%', },
                        { Header: 'Régimen general', accessor: 'regimenGeneral', Cell: ({ value }) => value ? 'Sí' : 'No', },
                        { Header: 'Fecha baja', accessor: 'fechaBaja', width: '20%', Cell: ({ value }) => getDateToString(value, false) },
                    ]}
                />
            )}

            {editItem && (
                <RubroModal
                    rubro={editItem}
                    editMode={editMode}
                    onConfirm={onEditConfirm}
                    onCancel={onEditCancel}
                />
            )}
        </section>
    </>
}

export default RubrosView
